import { createSlice } from '@reduxjs/toolkit'

// BE-27. A finer-grained expense type under a head — e.g. Utilities >
// Electricity, Utilities > Water — same narrowing reasoning as
// ExpenseCategorySlice: settles_customer_due is fixed false by
// ExpenseSubCategoryApiService, since a sub-category filed under an expense
// head can never be the one that pays off a customer's due.
export const ExpenseSubCategorySlice = createSlice({
    name: 'expenseSubCategory',
    initialState: {
        expenseSubCategoryList: [],
        formValue: {
            "credit_category_id": "",
            "name": "",
        }
    },
    reducers: {
        onChangeExpenseSubCategoryFormInput: (state, action) => {
            state.formValue[`${action.payload.name}`] = action.payload.value;
        },
        resetExpenseSubCategoryFormValue: (state) => {
            Object.keys(state.formValue).forEach((i) => state.formValue[i] = "");
        },
        setExpenseSubCategoryList: (state, action) => {
            state.expenseSubCategoryList = action.payload
        },
    },
})

export const {
    onChangeExpenseSubCategoryFormInput,
    resetExpenseSubCategoryFormValue,
    setExpenseSubCategoryList,
} = ExpenseSubCategorySlice.actions

export default ExpenseSubCategorySlice.reducer
